import React, { useState, useEffect } from "react";

function WHGTd({ dataHeader, onClick, activeTime, deactiveTime, edit }: any) {
  const [active, setactive] = useState(false);

  useEffect(() => {
    if (activeTime && deactiveTime) {
      setactive(true);
    } else {
      setactive(false);
    }
  }, [activeTime, deactiveTime]);

  const handleClick = () => {
    if (edit && activeTime) {
      setactive(!active);
      onClick({ ...dataHeader, active: !active });
    }
  };

  return (
    <td className="px-2 py-2 text-center">
      <button
        onClick={handleClick}
        disabled={!edit || !activeTime}
        className={`w-8 h-8 rounded-lg transition-all ${
          !activeTime
            ? "bg-slate-100 cursor-not-allowed"
            : active
            ? "bg-amber-500 shadow-md shadow-amber-200"
            : "bg-slate-200"
        } ${
          edit && activeTime
            ? "cursor-pointer hover:scale-110"
            : "cursor-default"
        }`}
      />
    </td>
  );
}

export default WHGTd;
